
import {defineComponent} from 'vue';
import clickOutsideDirective from '../../../directives/click-outside';

export default defineComponent({
  name: 'oxd-calendar-dropdown',
  emits: ['select'],

  props: {
    options: {
      type: Array,
      required: true,
    },
    selected: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      isActive: false,
    };
  },

  directives: {
    'click-outside': clickOutsideDirective,
  },

  methods: {
    openSubmenu() {
      this.isActive = true;
      this.$nextTick(() => {
        const elm = this.$refs[`oxd-cal-ref-${this.selected}`];
        elm && this.scrollToView(elm);
      });
    },
    closeSubMenu() {
      if (this.isActive) {
        this.isActive = false;
      }
    },
    onSelectOption(option) {
      this.$emit('select', option);
    },
    scrollToView(elm: HTMLElement) {
      elm.scrollIntoView();
    },
  },
});
